/**
 * compatibility-search.js
 * Upload to: Shopify Admin → Online Store → Themes → Assets
 *
 * Handles ALL compatibility-search blocks on the page.
 * Each block is fully namespaced by its section UID so multiple
 * instances on the same page work independently.
 */

(function () {
  'use strict';

  var API = 'https://check.adaptermanual.com/api/h5/protocol/car/brand';

  /* -------------------------------------------------------------------------
     Helpers
  -------------------------------------------------------------------------- */
  function get(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('Network error: ' + r.statusText);
      return r.json();
    });
  }

  function clearSelect(sel) {
    while (sel.firstChild) sel.removeChild(sel.firstChild);
  }

  function emptyOption(sel) {
    var o = document.createElement('option');
    o.value = '';
    o.disabled = true;
    o.selected = true;
    sel.appendChild(o);
  }

  function fillSelect(sel, items) {
    emptyOption(sel);
    (items || []).forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      sel.appendChild(o);
    });
  }

  function addOtherOption(sel, label) {
    var o = document.createElement('option');
    o.value = 'other';
    o.textContent = label || 'Other';
    sel.appendChild(o);
  }

  /* -------------------------------------------------------------------------
     Init one block
  -------------------------------------------------------------------------- */
  function initBlock(uid) {
    /* DOM refs */
    var wrapper      = document.getElementById('ot-car-camp-wrapper-' + uid);
    var triggerBtn   = document.getElementById('checkCompatibilityBtn-' + uid);
    var brandSel     = document.getElementById('select-' + uid + '--brand');
    var modelSel     = document.getElementById('select-' + uid + '--model');
    var yearSel      = document.getElementById('select-' + uid + '--years');
    var searchBtn    = wrapper.querySelector('[aria-controls="result-dialog-' + uid + '"]');
    var resultDialog = document.getElementById('result-dialog-' + uid);
    var resultBox    = document.getElementById('compatibility-result-' + uid);

    if (!wrapper || !triggerBtn || !brandSel || !modelSel || !yearSel || !searchBtn || !resultDialog || !resultBox) {
      return; // block elements missing — bail
    }

    var closeResultBtn = resultBox.querySelector('.close');
    var state = { brand: '', model: '', year: '' };

    /* -------------------------------------------------------------------
       Open / close outer modal
    ------------------------------------------------------------------- */
    function openModal() {
      wrapper.classList.remove('f_hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      wrapper.classList.add('f_hidden');
      document.body.style.overflow = '';
    }

    triggerBtn.addEventListener('click', openModal);

    var closeX = wrapper.querySelector('.ot-car-camp-close');
    if (closeX) closeX.addEventListener('click', closeModal);

    wrapper.addEventListener('click', function (e) {
      if (e.target === wrapper) closeModal();
    });

    /* -------------------------------------------------------------------
       Open / close result dialog
    ------------------------------------------------------------------- */
    function openResultDialog() {
      resultDialog.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }

    function closeResultDialog() {
      resultDialog.style.display = 'none';
      document.body.style.overflow = 'hidden'; // modal still open underneath
      /* clear cloned content but keep the static close button */
      var kids = Array.prototype.slice.call(resultBox.children);
      kids.forEach(function (k) {
        if (!k.classList.contains('close')) resultBox.removeChild(k);
      });
    }

    if (closeResultBtn) closeResultBtn.addEventListener('click', closeResultDialog);

    resultDialog.addEventListener('click', function (e) {
      if (e.target === resultDialog) closeResultDialog();
    });

    /* -------------------------------------------------------------------
       Full close (both dialogs) — used by "Continue Shopping" etc.
    ------------------------------------------------------------------- */
    function closeAll() {
      closeResultDialog();
      closeModal();
      /* reset selects */
      clearSelect(brandSel); emptyOption(brandSel);
      clearSelect(modelSel); emptyOption(modelSel);
      clearSelect(yearSel);  emptyOption(yearSel);
      searchBtn.disabled = true;
      state.brand = state.model = state.year = '';
      /* reload brands so modal is fresh if re-opened */
      loadBrands();
    }

    /* -------------------------------------------------------------------
       Show result template
    ------------------------------------------------------------------- */
    function showResult(code, vehicleLabel) {
      var template = document.getElementById('result-' + code + '-' + uid);
      if (!template) {
        console.warn('[CompatSearch] No result template for code:', code);
        return;
      }

      /* wipe previous cloned content */
      var kids = Array.prototype.slice.call(resultBox.children);
      kids.forEach(function (k) {
        if (!k.classList.contains('close')) resultBox.removeChild(k);
      });

      var node = template.cloneNode(true);
      node.removeAttribute('id');
      node.style.display = 'block';

      /* inject vehicle label */
      var ctnt = node.querySelector('.dog-selected-ctnt');
      if (ctnt) ctnt.textContent = vehicleLabel;

      resultBox.appendChild(node);
      openResultDialog();

      /* wire buttons inside cloned node */
      node.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();

          /* "Watch Guide Video" button */
          var openWrap = btn.closest('.dog-v-dog-open');
          if (openWrap) {
            var vId  = openWrap.dataset.vDogId;
            var vWrap = document.querySelector('.dog-v-dog-wrapper-' + vId);
            if (vWrap) openVideoLightbox(vWrap);
            return;
          }

          /* "Continue Shopping" / "Order Now" (handled by <a> parent) */
          var isShop = btn.closest('.dog-continue-shop');
          if (isShop) { closeAll(); return; }

          /* fallback */
          closeAll();
        });
      });
    }

    /* -------------------------------------------------------------------
       Video lightbox
    ------------------------------------------------------------------- */
    function openVideoLightbox(vWrap) {
      vWrap.classList.remove('f_hidden');
      document.body.style.overflow = 'hidden';

      function closeLightbox(e) {
        if (e && e.target !== vWrap && !e.target.closest('.dog-v-dog-close')) return;
        vWrap.classList.add('f_hidden');
        var vid = vWrap.querySelector('video');
        if (vid) vid.pause();
        document.body.style.overflow = 'hidden'; // modal still behind
        vWrap.removeEventListener('click', closeLightbox);
      }

      vWrap.addEventListener('click', closeLightbox);

      var closeX = vWrap.querySelector('.dog-v-dog-close');
      if (closeX) {
        closeX.addEventListener('click', function () {
          closeLightbox({ target: closeX });
        }, { once: true });
      }
    }

    /* -------------------------------------------------------------------
       API: load brands
    ------------------------------------------------------------------- */
    function loadBrands() {
      get(API + '/selectAllBrand').then(function (data) {
        clearSelect(brandSel);
        fillSelect(brandSel, data.data);
        addOtherOption(brandSel);
        searchBtn.disabled = true;
      }).catch(function (err) {
        console.error('[CompatSearch] Failed to load brands:', err);
      });
    }

    /* -------------------------------------------------------------------
       Selectors
    ------------------------------------------------------------------- */
    brandSel.addEventListener('change', function () {
      state.brand = this.value;
      clearSelect(modelSel); emptyOption(modelSel);
      clearSelect(yearSel);  emptyOption(yearSel);
      searchBtn.disabled = true;
      state.model = state.year = '';

      if (state.brand === 'other') {
        showResult('2', 'Other');
        return;
      }

      get(API + '/selectAllModelOfBrand?brandName=' + encodeURIComponent(state.brand))
        .then(function (data) {
          clearSelect(modelSel);
          fillSelect(modelSel, data.data);
        })
        .catch(function (err) {
          console.error('[CompatSearch] Failed to load models:', err);
        });
    });

    modelSel.addEventListener('change', function () {
      state.model = this.value.replace(/ /g, '+');
      clearSelect(yearSel); emptyOption(yearSel);
      searchBtn.disabled = true;
      state.year = '';

      get(API + '/selectAllYearsOfModelAndBrand?brandName=' + encodeURIComponent(state.brand) + '&carName=' + encodeURIComponent(state.model))
        .then(function (data) {
          clearSelect(yearSel);
          fillSelect(yearSel, data.data);
          addOtherOption(yearSel);
        })
        .catch(function (err) {
          console.error('[CompatSearch] Failed to load years:', err);
        });
    });

    yearSel.addEventListener('change', function () {
      state.year = this.value;
      searchBtn.disabled = false;
    });

    /* -------------------------------------------------------------------
       Search
    ------------------------------------------------------------------- */
    searchBtn.addEventListener('click', function () {
      var label = state.brand + ' ' + state.model.replace(/\+/g, ' ') + ', ' + state.year;

      if (state.year === 'other') {
        showResult('0', label);
        return;
      }

      setButtonLoading(searchBtn, true);

      get(API + '/compatibilitySelectForStation?brandName=' + encodeURIComponent(state.brand) + '&carName=' + encodeURIComponent(state.model) + '&productionYear=' + encodeURIComponent(state.year))
        .then(function (data) {
          showResult(String(data.data), label);
        })
        .catch(function (err) {
          console.error('[CompatSearch] Compatibility check failed:', err);
        })
        .finally(function () {
          setButtonLoading(searchBtn, false);
        });
    });

    /* -------------------------------------------------------------------
       Button loading state
    ------------------------------------------------------------------- */
    function setButtonLoading(btn, loading) {
      if (loading) {
        btn.classList.add('is-loading');
        btn.disabled = true;
      } else {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    }

    /* -------------------------------------------------------------------
       Bootstrap
    ------------------------------------------------------------------- */
    loadBrands();
  }

  /* -------------------------------------------------------------------------
     Auto-discover all blocks on the page
     Looks for elements with id matching "ot-car-camp-wrapper-*"
  -------------------------------------------------------------------------- */
  function init() {
    var wrappers = document.querySelectorAll('[id^="ot-car-camp-wrapper-"]');
    wrappers.forEach(function (el) {
      var uid = el.id.replace('ot-car-camp-wrapper-', '');
      if (uid) initBlock(uid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* -------------------------------------------------------------------------
     Shopify Section Events — re-init when section is reloaded in theme editor
  -------------------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    var wrapper = section.querySelector('[id^="ot-car-camp-wrapper-"]');
    if (wrapper) {
      var uid = wrapper.id.replace('ot-car-camp-wrapper-', '');
      if (uid) initBlock(uid);
    }
  });

})();